import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import initialValues from '../../validation/register-loss-adjusters-training/initialValues';
import validationSchema from '../../validation/register-loss-adjusters-training/validationSchema';
import formModel from '../../validation/register-loss-adjusters-training/formModel';
import InputField from './form-fields/InputField';
import RadioField from './form-fields/RadioField';
import WebsiteForms from './WebsiteForms';

const RegisterLossAdjustersFormRoot = styled('div')(({ theme }) => ({
    padding: '50px 0',
}));

const RegisterLossAdjustersForm = () => {
    const {
        firstName,
        lastName,
        idNumber,
        email,
        contactNumber,
        companyName,
        registeredCiaLA,
    } = formModel;

    return (
        <RegisterLossAdjustersFormRoot>
            <WebsiteForms
                formUrl="api/forms/registeronlinelossadjusterstraining"
                initialValues={initialValues}
                validationSchema={validationSchema}
            >
                <Grid container spacing={7}>
                    <Grid item xs={12} sm={6}>
                        <InputField name={firstName.name} label={firstName.label} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputField name={lastName.name} label={lastName.label} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputField name={idNumber.name} label={idNumber.label} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputField name={email.name} label={email.label} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputField
                            name={contactNumber.name}
                            label={contactNumber.label}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputField name={companyName.name} label={companyName.label} fullWidth />
                    </Grid>
                    <Grid item xs={12}>
                        <RadioField
                            name={registeredCiaLA.name}
                            label={registeredCiaLA.label}
                        />
                    </Grid>
                </Grid>
            </WebsiteForms>
        </RegisterLossAdjustersFormRoot>
    );
};

export default RegisterLossAdjustersForm;
